/* MS4L search — поп-ап поиска (3 колонки) + добор счётчиков на странице результатов.
   Всё содержимое рендерит сервер: подсказки из /search/suggest.json, счётчики из
   секций ms4l-search-facets / ms4l-search-count. Анимация только раскрывает готовое,
   поэтому краулеры и AI-движки видят полную структуру страницы результатов. */
(function () {
  'use strict';
  var MIN = 2, DEB = 220, LIMP = 20, LIMC = 6, LIMQ = 4;
  /* suggest.json отдаёт price строкой в долларах ('1403.00'), не в центах */
  var money = function (v) {
    var n = typeof v === 'number' ? v : parseFloat(String(v || '').replace(/[^0-9.]/g, ''));
    if (!isFinite(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  /* подсветка ПРЕДСКАЗАННОЙ части, а не введённой (Baymard) */
  function hl(text, q) {
    var t = String(text || ''), lq = q.toLowerCase(), i = t.toLowerCase().indexOf(lq);
    if (i !== 0) return esc(t);
    return esc(t.slice(0, lq.length)) + '<b>' + esc(t.slice(lq.length)) + '</b>';
  }


  /* --- порядок категорий: сначала готовые системы, отдельные блоки и запчасти вниз --- */
  /* три уровня: сначала готовые системы, потом отдельные блоки, в самом низу запчасти */
  var T_UNITS = /indoor unit|outdoor unit|condenser/i;
  var T_PARTS = /accessor|hvac part|^part\b|air filter|filter$/i;
  function tier(label) {
    var l = String(label || '');
    if (T_PARTS.test(l)) return 2;
    if (T_UNITS.test(l)) return 1;
    return 0;
  }
  function byTierCount(a, b) { return (tier(a.label) - tier(b.label)) || (b.count - a.count); }

  /* --- мощность из запроса: 36000 / 36,000 / 36k / 3 ton --- */
  function wantedBtu(q) {
    var s = String(q || '').toLowerCase().replace(/,/g, '');
    var m = s.match(/(\d{4,6})\s*(?:btu)?/);
    if (m) { var n = parseInt(m[1], 10); if (n >= 5000 && n <= 120000) return n; }
    m = s.match(/(\d{1,3})\s*k\b/);
    if (m) { var k = parseInt(m[1], 10) * 1000; if (k >= 5000 && k <= 120000) return k; }
    m = s.match(/([\d.]+)\s*ton/);
    if (m) { var t = Math.round(parseFloat(m[1]) * 12000); if (t >= 5000 && t <= 120000) return t; }
    return null;
  }
  function titleHasBtu(title, n) {
    var s = String(title || '').toLowerCase().replace(/,/g, '');
    /* 21.08: сравниваем ПЕРВОЕ число BTU в названии — это мощность системы.
       Раньше «24k» матчился где угодно, и 48K-четырёхзонник с головой 24k
       считался «точным» ответом на запрос 24000 — сбивало покупателей. */
    var m = s.match(/(\d{4,6})\s*btu/);
    if (m) return parseInt(m[1], 10) === n;
    if (s.indexOf(String(n)) > -1) return true;
    return s.indexOf(String(Math.round(n / 1000)) + 'k') > -1;
  }


  /* логотипы брендов — те же файлы, что в блоке «Our Trusted Brands» на главной.
     Ширина через &width= у Shopify CDN, поэтому адаптивно и без лишнего веса. */
  var BLOGO = [
    { re: /cooper/i,  src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/C_H.png?v=1741975758' },
    { re: /olmo/i,    src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/OLMO.png?v=1741975780' },
    { re: /bravo/i,   src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/Bravo.png?v=1741975796' }
  ];
  function logoFor(label) {
    for (var i = 0; i < BLOGO.length; i++) if (BLOGO[i].re.test(label)) return BLOGO[i].src;
    return null;
  }


  /* миниатюры типов — те же файлы, что в мега-меню шапки */
  var CDN = 'https://minisplitsforless.com/cdn/shop/files/';
  var TYPEIMG = [
    { re: /^accessor|hvac accessor|air filter/i,  src: 'https://minisplitsforless.com/cdn/shop/files/Untitled_design_1.png?format=pjpg&v=1760468159' },
    { re: /hvac part|^part/i,                     src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-asm135d23ufz-11103020a00015-dc-inverter-rotary-675.webp' },
    { re: /indoor unit/i,                         src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/bravo-milano-24-000-btu-indoor-wall-mount-230v-r32-ductless-mini-441.webp' },
    { re: /outdoor unit|condenser/i,              src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/cooper-hunter-mes-series-18-000-btu-outdoor-condenser-230v-r454b-768.webp' },
    { re: /one[- ]?way|1[- ]?way/i,            src: CDN + '3_zones_1-way_cassette-28-14.jpg?format=pjpg&v=1755117887' },
    { re: /ceiling cassette|4[- ]?way/i,       src: CDN + 'cooper-hunter-2-zone-36-000-btu-olivia-ductless-mini-split-ac-652.webp?format=pjpg&v=1753733810' },
    { re: /concealed duct|slim duct|ducted/i,  src: CDN + 'cooper-hunter-5-zone-55-000-btu-olivia-ducted-mini-split-ac-217.webp?format=pjpg&v=1745862565' },
    { re: /multi position/i,                   src: CDN + 'cooper-hunter-24-000-btu-230v-ducted-mini-split-ac-multi-positional-720_fc655487-cf00-4da6-9fe1-3438173b347a.webp?format=pjpg&v=1758902022' },
    { re: /universal floor|floor\s*\/\s*ceiling/i, src: CDN + 'cooper-hunter-48-000-btu-2-zone-24k-24k-universal-floor-ceiling-572.webp?format=pjpg&v=1741623744' },
    { re: /floor console/i,                    src: CDN + 'cooper-hunter-16-000-btu-230v-ductless-mini-split-ac-floor-console-304.webp?format=pjpg&v=1744985872' },
    { re: /wall mount/i,                       src: CDN + 'cooper-hunter-5-zone-48-000-btu-hyper-series-ductless-mini-split-ac-384.webp?format=pjpg&v=1745614385' },
    { re: /ptac|pthp/i,                        src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/cooper-hunter-15-000-btu-ptac-air-conditioner-heat-pump-heating-510.webp?v=1743604808' },
    { re: /through[- ]?the[- ]?wall|\bttw\b/i, src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/olmo-8-000-btu-115v-through-the-wall-air-conditioner-w-remote-smart-105.webp?v=1743614172' },
    { re: /portable/i,                         src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/cooper-hunter-14-000-btu-duo-hose-portable-ac-and-heater-up-to-550-755.webp?v=1741621049' },
    /* 18.09.2026: типы, у которых иконки не было и рисовался пустой серый квадрат */
    { re: /^pcb/i,                   src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-w8433cav1-1-10000100013-electric-box-assy-233.webp?v=1782489742' },
    { re: /compressor/i,             src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-asm135d23ufz-11103020a00015-dc-inverter-rotary-675.webp?v=1782400581' },
    { re: /fan motor/i,              src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-zkfp-20-8-6-7-11002015000051-indoor-brushless-dc-930.webp?v=1782485705' },
    { re: /fan blower|^blower/i,     src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-zl-560-139-12-3kn-12100105000084-axial-flow-fan-401.webp?v=1782488398' },
    { re: /other part/i,             src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/hvac-express-parts-kfr105w-bp3t1n1-e30-17122000050082-inverter-543.webp?v=1782497795' },
    { re: /humidity|dehumidif/i,     src: 'https://cdn.shopify.com/s/files/1/0558/6914/5280/files/cooper-hunter-60-pint-dehumidifier-w-drain-pump-hose-6l-water-tank-732.webp?v=1740746669' }
  ];
  function typeImg(label) {
    for (var i = 0; i < TYPEIMG.length; i++) if (TYPEIMG[i].re.test(label)) return TYPEIMG[i].src;
    return null;
  }
  function thumb(src, alt, isCover) {
    if (!src) return '<span class="ms4l-ac__tico ms4l-ac__tico--none" aria-hidden="true"></span>';
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    return '<img class="ms4l-ac__tico' + (isCover ? ' ms4l-ac__tico--cover' : '') + '" alt="" loading="lazy" src="' + src + sep + 'width=96" ' +
           'srcset="' + src + sep + 'width=96 1x, ' + src + sep + 'width=192 2x">';
  }

  /* 24.09.2026: значок с числом для размерных категорий.
     Порядок: кураторская иконка типа -> значок -> обложка коллекции -> пустая рамка.
     Обоснование в scripts/bi/apply_search_size_badges.py */
  function sizeBadge(label) {
    var s = String(label || '');
    var m = s.match(/([\d][\d,]*)\s*BTU/i);
    if (m) {
      var n = parseFloat(m[1].replace(/,/g, ''));
      if (n >= 1000) return Math.round(n / 1000) + 'K';
      return String(n);
    }
    m = s.match(/([\d]+(?:\.[\d]+)?)\s*TON/i);
    if (m) return (Math.round(parseFloat(m[1]) * 10) / 10) + 'T';
    m = s.match(/(\d+)\s*[-\s]?zones?\b/i);
    if (m) return m[1] + 'Z';
    return null;
  }
  function numTico(txt) {
    var cls = 'ms4l-ac__tico ms4l-ac__tico--num' + (txt.length > 3 ? ' ms4l-ac__tico--num-sm' : '');
    return '<span class="' + cls + '" aria-hidden="true">' + esc(txt) + '</span>';
  }
  function tico(label, fallbackSrc) {
    var ti = typeImg(label);
    if (ti) return thumb(ti, label, false);
    var b = sizeBadge(label);
    if (b) return numTico(b);
    if (fallbackSrc) return thumb(fallbackSrc, label, true);
    return thumb(null, label, false);
  }


  /* Популярные запросы — реальная статистика: Search & Discovery + GA4 за 30 дней.
     Ведут в готовые коллекции, где они есть, иначе в поиск. */
  var RKEY = 'ms4l_recent';
  /* В «Recent searches» только короткие запросы латиницей: магазин для США, а абзац текста, вставленный
     в поиск по ошибке, не должен висеть в подсказке и вылезать за край. Старые такие записи
     скрываются при чтении и вычищаются при следующем поиске. 21.10.2026 */
  function okRecent(x) { return typeof x === 'string' && x.length <= 80 && !/[^\u0000-\u024F\u2010-\u2033]/.test(x); }
  function recent() {
    try { return (JSON.parse(localStorage.getItem(RKEY)) || []).filter(okRecent).slice(0, 4); } catch (e) { return []; }
  }
  function pushRecent(q) {
    q = String(q || '').trim(); if (q.length < 2 || !okRecent(q)) return;
    try {
      var l = (JSON.parse(localStorage.getItem(RKEY)) || []).filter(okRecent).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q); localStorage.setItem(RKEY, JSON.stringify(l.slice(0, 8)));
    } catch (e) {}
  }


  /* --- запрос похож на номер запчасти? --- */
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function isPartQuery(q) {
    var t = String(q || '').trim();
    if (/\bbtu\b|\bzone\b|\bton\b|cassette|wall mount|duct|seer/i.test(t)) return false;
    var n = norm(t);
    if (n.length < 7) return false;
    if (/^\d{7,}$/.test(n)) return true;                       /* 17122000055296 */
    if (/\d/.test(n) && /[A-Z]/.test(n) && n.length >= 8) return true; /* US-KFR26G/BP3N1Y-ABA, ASM135D23UFZ */
    return false;
  }
  function exactPart(p, q) {
    var n = norm(q);
    return norm(p.sku).indexOf(n) > -1 || norm(p.skus).indexOf(n) > -1 || norm(p.title).indexOf(n) > -1;
  }


  /* --- мобильная строка поиска в потоке страницы (как в референсе instrumentall):
         видна сразу при заходе, уезжает при скролле вместе со страницей,
         результаты выводятся под ней одной панелью, без всплывающей карточки --- */
  function mobileBar() {
    if (window.matchMedia('(min-width: 1024px)').matches) return;
    /* 01.09: строку отдаёт sections/header-mobile-navigation.liquid. Если она
       уже в DOM — не создаём вторую, а подключаем автокомплит к её форме. */
    var served = document.querySelector('.ms4l-msbar');
    if (served) { var sf = served.querySelector('form'); if (sf) AC(sf); return; }
    var hdr = document.querySelector('theme-header') || document.querySelector('.header-section') ||
              document.querySelector('header');
    if (!hdr) return;
    var bar = document.createElement('div');
    bar.className = 'ms4l-msbar';
    bar.innerHTML =
      '<form role="search" method="get" action="/search" class="ms4l-msbar__form">' +
        '<input type="hidden" name="type" value="product">' +
        '<span class="ms4l-msbar__wrap searchform--form">' +
          '<input class="search-field ms4l-msbar__input" type="text" name="q" ' +
            'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ' +
            'placeholder="36,000 BTU, cassette, brand\u2026" aria-label="Search products" data-ms4l-ph="1">' +
          '<button type="submit" class="thb-search-submit ms4l-msbar__go" aria-label="Search">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" ' +
            'stroke="currentColor" stroke-width="2"/><path d="M16.5 16.5L21 21" stroke="currentColor" ' +
            'stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</span>' +
      '</form>';
    hdr.parentNode.insertBefore(bar, hdr.nextSibling);
    AC(bar.querySelector('form'));
  }


  /* --- «топ выдача» для КАЖДОГО запроса: ранжируем внутри результата, а не по
         абсолютному порогу продаж. Иначе на редких мощностях топа не было вовсе. --- */
  var TOPN = 5;
  /* 06.08: сколько зон просят в запросе. Shopify ищет по словам по отдельности,
     поэтому на «wallmount single zone» в выдачу лезли двух- и трёхзонники. */
  function wantedZones(q) {
    var s = String(q || '').toLowerCase();
    if (/(single[\s-]?zone|1[\s-]zone|one[\s-]zone)/.test(s)) return 1;
    if (/(2[\s-]?zone|two[\s-]?zone|dual[\s-]?zone)/.test(s)) return 2;
    if (/(3[\s-]?zone|three[\s-]?zone|tri[\s-]?zone)/.test(s)) return 3;
    if (/(4[\s-]?zone|four[\s-]?zone|quad[\s-]?zone)/.test(s)) return 4;
    if (/(5[\s-]?zone|five[\s-]?zone)/.test(s)) return 5;
    if (/\bsingle\b/.test(s)) return 1;
    return 0;
  }
  /* сколько зон у товара по заголовку; 0 — не определилось, такие не отсеиваем */
  function zoneOf(t) {
    var s = String(t || '').toLowerCase();
    if (/single[\s-]?zone/.test(s)) return 1;
    if (/dual[\s-]?zone/.test(s)) return 2;
    if (/tri[\s-]?zone/.test(s)) return 3;
    var m = s.match(/(\d)[\s-]?zone/);
    return m ? parseInt(m[1], 10) : 0;
  }
  /* ---- 06.08: аналитика поиска --------------------------------------
     Тема шлёт `search` только на /search, а из поп-апа покупатель уходит
     прямо на карточку — без своих событий такие поиски не видны вообще. */
  var MS4L_GA = 'G-8B9BH0BS0B';
  function trk(name, params) {
    try {
      if (typeof gtag !== 'function') return;
      var p = params || {};
      p.send_to = MS4L_GA;               /* только GA4, контейнеры Ads не трогаем */
      gtag('event', name, p);
    } catch (e) {}
  }
  var trkLast = '', trkT = null;
  /* запрос считаем «состоявшимся» через 1.2 c после последнего символа */
  function trkSearch(q, total, isPart, zones) {
    if (!q || q === trkLast) return;
    clearTimeout(trkT);
    trkT = setTimeout(function () {
      if (q === trkLast) return;
      trkLast = q;
      trk(total ? 'ms4l_search' : 'ms4l_search_zero',
          { search_term: q, results: total || 0, is_part: !!isPart, zones: zones || 0 });
    }, 1200);
  }
  /* атрибуты корзины: заказ потом можно связать с запросом по note_attributes */
  function trkCart(q) {
    try {
      var first = sessionStorage.getItem('ms4lQ1');
      if (!first) { first = q; sessionStorage.setItem('ms4lQ1', q); }
      var body = 'attributes[ms4l_search]=' + encodeURIComponent(first) +
                 '&attributes[ms4l_search_last]=' + encodeURIComponent(q) +
                 '&attributes[ms4l_search_at]=' + encodeURIComponent(new Date().toISOString());
      fetch('/cart/update.js', { method: 'POST', headers:
        { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body, keepalive: true });
    } catch (e) {}
  }
  function pscore(p) {
    var s = 0;
    if (p.available) s += 1000000;                /* распроданное никогда не в топе */
    s += (p.sold || 0) * 1000;                    /* ПРОДАЖИ — главный критерий */
    var pr = parseFloat(p.price || 0);
    var cap = parseFloat(p.cap || p.compare_at_price_min || 0);
    if (cap > pr && cap > 0) s += Math.round((cap - pr) / cap * 100);       /* скидка только как тайбрейк */
    return s;
  }
  /* 20.08: аксессуары и одиночные блоки — вниз, если запрос не про них.
     Покупатель, набравший «60000», ищет систему; комплект трубок с сотнями
     продаж не должен стоять выше систем. Штраф 500 000 держит аксессуар ниже
     любой системы в наличии, но выше распроданного. */
  var ACC_TYPES = { 'accessories': 1, 'hvac accessories': 1, 'hvac part': 1, 'air filter': 1, 'humidity control': 1 };
  function accQuery(q) {
    return /kit|line ?set|bracket|filter|cover|remote|wi-?fi|sleeve|board|motor|blower|pcb|drain|pan\b|pump|adapter|thermostat|part|accessor|sensor|wire/i.test(q);
  }
  function unitQuery(q) {
    return /indoor|outdoor|condenser|air ?handler|ahu|individual|head/i.test(q);
  }
  function catPen(p, q) {
    var t = String(p.ptype || '').toLowerCase();
    if (ACC_TYPES[t]) return accQuery(q) ? 0 : 500000;
    if ((t === 'indoor unit' || t === 'outdoor unit') && !unitQuery(q)) return 500000;
    return 0;
  }


  /* --- «ИИ-подсказки», когда точного совпадения нет.
         На деле — ближайшие мощности из нашего каталога и похожие термины. --- */
  var CAPS = [6000,9000,12000,16000,18000,19000,24000,27000,28000,30000,36000,42000,48000,55000,60000];
  /* 20.08: какие зоны реально существуют на каждую мощность — снято со ВСЕГО
     активного каталога (5 474 товара), а не с первых 50 результатов выдачи.
     Пересобрать при смене ассортимента: см. reports/bi/zones_best_instock_20aug.json (только В НАЛИЧИИ и только по мощности СИСТЕМЫ (тег -v-o), см. reports/bi/zones_best_vo_21aug.json) */
  var ZONECAP = {"6000":[1],"9000":[1],"12000":[1],"18000":[1,2,3],"19000":[2,3],"24000":[1,2,3],"28000":[2,3,4],"30000":[1,2,3,4],"36000":[1,2,3,4,5],"42000":[2,3,4,5],"48000":[1,2,3,4,5,6],"55000":[2,3,4,5,6],"60000":[1,2,3,4,5,6]};
  /* 20.08: топ-6 бестселлеров на мощность (handle + продажи). Секция отдаёт
     первые 250 результатов по релевантности Shopify, а лучшие по продажам
     товары часто сидят глубже (у 55K — все). Недостающих дозагружаем живьём
     через /products/<handle>.js: цена и наличие всегда актуальные, продажи из
     карты. Пересборка: reports/bi/zones_best_instock_20aug.json (только В НАЛИЧИИ) */
  var BESTCAP = {"6000":[{"h":"cooper-hunter-mia-series-mini-split-air-conditioner-and-heater-btu-115v-21-5-seer-2-6-000-er2-wall-mount-ductless-inverter","s":311},{"h":"cooper-hunter-olivia-series-hyper-6-000-btu-230v-23-5-seer-ductless-mini-split-ac-heater-with-installation-kit","s":11}],"8000":[{"h":"8-000-btu-115v-through-the-wall-air-conditioner-with-remote-control-and-built-in-smart-kit-cooling-only-r32-refrigerant","s":140},{"h":"cooper-hunter-12-000-btu-ptac-packaged-terminal-air-conditioner-with-heat-pump-pthp-heating-and-cooling-with-electric-cord-and-remote-control-copy","s":18}],"9000":[{"h":"cooper-hunter-9-000-btu-208-230v-18-seer-ductless-mini-split-air-conditioner-heat-pump-mia-ny-series-wi-fi-included-installation-kit-option","s":243},{"h":"cooper-hunter-9-000-btu-230v-ceiling-cassette-ductless-mini-split-air-conditioner-heat-pump-21-6-seer-ch-rh09mct-230","s":78},{"h":"cooper-hunter-olivia-series-midnight-edition-9-000-btu-230v-24-seer-ductless-mini-split-ac-heater-with-black-mirror-panel-installation-kit-option-wi-fi-adapter-included","s":37},{"h":"cooper-hunter-mia-9-000-btu-single-zone-wall-mount-115v-r454b-ductless-mini-split-air-conditioner-heat-pump","s":23},{"h":"9-000-btu-one-way-ceiling-cassette-22-5-seer-208-230v-installation-kit-option-ch-09mct1w-230vi-ch-es09-230vo","s":13},{"h":"bravo-milano-9-000-btu-indoor-wall-mount-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":10}],"12000":[{"h":"12-000-btu-115v-ductless-mini-split-air-conditioner-and-heat-pump-ch-ng12mia115vi-o","s":566},{"h":"cooper-hunter-12-000-btu-208-230v-ductless-mini-split-air-conditioner-and-heat-pump-wifi-ready-19-seer-installation-kit-ch-ng12mia230vi-o","s":466},{"h":"cooper-hunter-12-000-btu-230v-ductless-mini-split-air-conditioner-ch-rhp12-230vi-o","s":178},{"h":"ch-12msphct-230vi-12-000-btu-230v-cassette-single-zone-ductless-mini-split-air-conditioner-heat-pump-1-ton","s":134},{"h":"12000-btu-17-seer-bravo-mini-split-heat-pump-air-conditioner-115v","s":95},{"h":"cooper-hunter-olivia-series-midnight-edition-12-000-btu-115v-23-2-seer-ductless-mini-split-ac-heater-with-black-mirror-panel-installation-kit-option","s":92}],"14000":[{"h":"14-000-btu-230v-through-the-wall-air-conditioner-with-remote-control-and-built-in-smart-kit-heating-and-cooling-r32-refrigerant","s":60},{"h":"14-000-btu-230v-through-the-wall-air-conditioner-with-remote-control-and-built-in-smart-kit-cooling-only-r32","s":17}],"15000":[{"h":"olmo-15-000-btu-ptac-packaged-terminal-air-conditioner-with-heat-strip-r32-refrigerant-and-3-5-kw-electric-heater-including-wireless-smart-kit-remote-controller-and-a-power-cord","s":28}],"18000":[{"h":"ch-ng18mia230vi-o-cooper-hunter-18-000-btu-230v-ductless-mini-split-air-conditioner-wifi-ready-heat-pump-19-seer","s":803},{"h":"18-000-btu-2-zone-9k-12k-with-installation-kits-drainage-22-9-seer-1-5-ton-dual-zone-ductless-mini-split-air-conditioner","s":188},{"h":"18-000-btu-2-zone-9k-9k-installation-kits-drainage-22-9-seer-1-5-ton-dual-zone-ductless-mini-split-air-conditioners","s":181},{"h":"2-zone-6k-12k-wall-mount-olivia-series-ductless-mini-split-a-c-and-heat-pump-with-25ft-installation-kits-wifi-ready","s":150},{"h":"18-000-btu-2-zone-12k-12k-with-installation-kits-drainage-and-wall-bracket-21-3-seer-1-5-ton-dual-zone-ductless-mini-split-air-conditioners","s":142},{"h":"cooper-hunter-18-000-btu-230v-cassette-ductless-mini-split-air-conditioner-heat-pump-20-8-seer-1-5-ton-ch-18mct-w","s":115}],"19000":[{"h":"cooper-hunter-olivia-hyper-19-000-btu-2-zone-9k-9k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":2},{"h":"cooper-hunter-olivia-hyper-19-000-btu-3-zone-6k-6k-9k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":1},{"h":"cooper-hunter-olivia-hyper-19-000-btu-2-zone-9k-12k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":1},{"h":"cooper-hunter-olivia-hyper-19-000-btu-2-zone-6k-18k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":1},{"h":"cooper-hunter-olivia-hyper-19-000-btu-2-zone-12k-12k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":1}],"24000":[{"h":"ch-ny24mia230vi-o-cooper-hunter-24-000-btu-208-230v-single-zone-18-7-seer-wall-mount-mia-ng-series-wifi-ready-ductless-mini-split-air-conditioner-system-heat-pump-cooling-and-heating","s":599},{"h":"cooper-hunter-24-000-btu-230v-concealed-duct-mini-split-air-conditioner-heat-pump-20-5-seer-2-ton-ch-m24dtui","s":238},{"h":"cooper-hunter-24-000-btu-230v-hyper-ductless-mini-split-air-conditioner-ch-hpr24-230vi-o","s":195},{"h":"cooper-hunter-24-000-btu-230v-ceiling-cassette-ductless-mini-split-air-conditioner-heat-pump-21-seer-2-ton-ch-24mct-w","s":165},{"h":"cooper-hunter-24-000-btu-2-ton-20-seer-heat-pump-split-system-with-multi-position-air-handler-unit-including-25ft-installation-kit","s":95},{"h":"24-000-btu-230v-18-seer-2-ton-ductless-mini-split-air-conditioner-heat-pump-16ft-installation-kit-wi-fi-adapter-included","s":83}],"28000":[{"h":"3-zone-6k-6k-18k-wall-mount-olivia-series-ductless-mini-split-a-c-and-heat-pump-with-25ft-installation-kits-wifi-ready","s":65},{"h":"3-zone-6k-6k-12k-wall-mount-olivia-series-ductless-mini-split-a-c-and-heat-pump-with-25ft-installation-kits-wifi-ready","s":57},{"h":"28-000-btu-3-zone-9k-9k-12k-ceiling-cassettes-with-installation-kits-24-6-seer2-2-3-ton-tri-zone-ductless-multi-mini-split-air-conditioner","s":50},{"h":"3-zone-6k-12k-18k-wall-mount-olivia-series-ductless-mini-split-a-c-and-heat-pump-with-25ft-installation-kits-wifi-ready","s":38},{"h":"3-zone-6k-9k-12k-wall-mount-olivia-series-ductless-mini-split-a-c-and-heat-pump-with-25ft-installation-kits-wifi-ready","s":33},{"h":"28-000-btu-3-zone-9k-9k-12k-hyper-ductless-mini-split-with-installation-kits-22-seer-2-3-ton-tri-zone-air-conditioner-system-wifi-ready","s":30}],"30000":[{"h":"30-000-btu-230v-ductless-mini-split-air-conditioner-wifi-ready-heat-pump-18-seer-2-5-ton-ch-30msphwm-230vi-o","s":75},{"h":"cooper-hunter-30-000-btu-230v-ductless-mini-split-ac-wall-mounted-olivia-series-heat-pump","s":51},{"h":"bravo-30-000-btu-3-zone-9000-9000-12000-btu-wall-mount-ductless-mini-split-a-c-and-heater-with-25ft-installation-kits","s":3},{"h":"bravo-30-000-btu-4-zone-9k-9k-9k-9k-wall-mount-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":2},{"h":"bravo-30-000-btu-4-zone-9k-9k-12k-12k-wall-mount-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":2},{"h":"bravo-30-000-btu-3-zone-9000-9000-12000-btu-ceiling-cassette-ductless-mini-split-a-c-and-heater-with-25ft-installation-kits","s":2}],"36000":[{"h":"cooper-hunter-36-000-btu-230v-ductless-mini-split-air-conditioner-ch-es36-230vi-o-olivia-series","s":371},{"h":"36000-btu-230v-mini-split-ac-wall-mounted-bravo-series-heat-pump","s":121},{"h":"ch-36mes230vo-36-000-btu-2-zone-12k-24k-with-installation-kits-drainage-and-24-seer-3-ton-dual-zone-ductless-multi-mini-split-air-conditioners","s":58},{"h":"36-000-btu-230v-sophia-concealed-duct-mini-split-air-conditioner-heat-pump-16-5-seer-2-ton-installation-kit-option-light-commercial","s":50},{"h":"36-000-btu-2-zone-18k-18k-with-installation-kits-drainage-and-wall-bracket-23-9-seer-3-ton-dual-zone-ductless-multi-mini-split-ch-36msph230vo-cooper-hunter","s":44},{"h":"cooper-hunter-36-000-btu-3-ton-15-8-seer-heat-pump-split-system-with-multi-position-air-handler-unit-installation-kit-option","s":43}],"42000":[{"h":"bravo-42-000-btu-5-zone-9000-9000-9000-9000-9000-btu-wall-mount-ductless-mini-split-a-c-and-heater-with-25ft-installation-kits","s":3},{"h":"bravo-42-000-btu-4-zone-9000-9000-12000-12000-btu-ceiling-cassette-ductless-mini-split-a-c-and-heater-with-25ft-installation-kits","s":3},{"h":"bravo-42-000-btu-3-zone-12000-12000-18000-btu-wall-mount-ductless-mini-split-a-c-and-heater-with-25ft-installation-kits","s":3},{"h":"bravo-milano-42-000-btu-outdoor-condenser-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":2},{"h":"bravo-42-000-btu-5-zone-9k-9k-9k-12k-18k-ceiling-cassette-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":2},{"h":"bravo-42-000-btu-5-zone-9k-9k-12k-12k-12k-ceiling-cassette-230v-r32-ductless-mini-split-air-conditioner-heat-pump","s":2}],"48000":[{"h":"copy-of-36-000-btu-230v-ceiling-cassette-light-commercial-ductless-mini-split-air-conditioner-heat-pump-16-seer-3-ton-installation-kit-option","s":57},{"h":"cooper-hunter-36-000-btu-230v-16-seer-universal-floor-ceiling-ductless-mini-split-air-conditioner-with-wall-thermostat-light-commercial-series-3-ton-single-zone-system-ahri-certified-copy","s":26},{"h":"copy-of-48-000-btu-230v-concealed-duct-17-4-seer-mini-split-air-conditioner-installation-kit-option-light-commercial-series-heating-and-cooling-heat","s":25},{"h":"cooper-hunter-48-000-btu-4-ton-17-7-seer-heat-pump-split-system-with-multi-position-air-handler-unit-installation-kit-option","s":23},{"h":"48-000-btu-2-zone-24k-24k-ceiling-cassette-with-installation-kits-drainage-and-2-4-seer2-4-ton-dual-zone-ductless-multi-mini-split-ac-system-ch-48mes230vo","s":15},{"h":"hyper-48-000-btu-230v-ducted-mini-split-ac-multi-positional-heat-pump","s":12}],"55000":[{"h":"cooper-hunter-olivia-hyper-55-000-btu-2-zone-9k-18k-wall-mount-230v-r454b-ductless-mini-split-ac-heat-pump","s":1}],"60000":[{"h":"60-000-btu-230v-ductless-universal-floor-ceiling-18-seer-mini-split-air-conditioner-ch-60lcfc-i","s":152},{"h":"60-000-btu-230v-concealed-duct-18-seer-mini-split-air-conditioner-installation-kit-option-light-commercial-series-heating-and-cooling-heat-pump","s":71},{"h":"cooper-hunter-60-000-btu-5-ton-17-seer-heat-pump-split-system-with-multi-position-air-handler-unit-installation-kit-option","s":35},{"h":"bravo-60-000-btu-multi-position-air-handler-side-discharge-heat-pump-inverter-r32-230v","s":6},{"h":"cooper-hunter-olivia-60-000-btu-2-zone-24k-30k-wall-mount-230v-r454b-ductless-mini-split-air-conditioner-heat-pump","s":4},{"h":"cooper-hunter-olivia-60-000-btu-2-zone-24k-36k-wall-mount-230v-r454b-ductless-mini-split-air-conditioner-heat-pump","s":3}]};
  var CAPCOLL = {6000:'/collections/6000-btu',9000:'/collections/9000-btu',12000:'/collections/12000-btu',
    18000:'/collections/18000-btu',24000:'/collections/24000-btu',30000:'/collections/30000-btu',
    36000:'/collections/36000-btu',42000:'/collections/42000-btu',48000:'/collections/48000-btu',
    60000:'/collections/60000-btu'};
  function nearestCaps(n, k) {
    return CAPS.slice().sort(function (a, b) { return Math.abs(a - n) - Math.abs(b - n); })
               .filter(function (c) { return c !== n; }).slice(0, k || 3);
  }
  var TERMS = ['wall mount','ceiling cassette','one-way cassette','concealed duct','slim duct',
    'universal floor ceiling','mini floor console','multi position air handler','outdoor unit','indoor unit',
    'condenser','thermostat','air filter','line set cover','disconnect box','condensate pump',
    'cooper & hunter','olmo','bravo','armbridge','hyper heat','olivia','sophia','sierra','pisa','midnight',
    'r32','r410a','r454b','single zone','multi zone','2 zone','3 zone','4 zone','5 zone','6 zone',
    'ptac','through the wall','portable','dehumidifier'];
  function lev(a, b) {
    a = String(a).toLowerCase(); b = String(b).toLowerCase();
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++)
      d[i][j] = Math.min(d[i-1][j] + 1, d[i][j-1] + 1, d[i-1][j-1] + (a[i-1] === b[j-1] ? 0 : 1));
    return d[m][n];
  }
  function nearestTerms(q, k) {
    var s = String(q || '').toLowerCase().trim();
    if (s.length < 3) return [];
    return TERMS.map(function (t) {
      var best = lev(s, t);
      t.split(' ').forEach(function (w) { best = Math.min(best, lev(s, w)); });
      return { t: t, d: best };
    }).filter(function (x) { return x.d <= Math.max(2, Math.round(x.t.length * 0.34)); })
      .sort(function (a, b) { return a.d - b.d; }).slice(0, k || 4).map(function (x) { return x.t; });
  }
  function sugChips(q, need, action) {
    var out = '';
    var caps = need ? nearestCaps(need, 3) : [];
    var terms = need ? [] : nearestTerms(q, 4);
    if (!caps.length && !terms.length) return '';
    out += '<div class="ms4l-ac__sug"><div class="ms4l-ac__sugh">' +
      (caps.length ? 'Closest capacities we carry' : 'Did you mean') + '</div><div class="ms4l-ac__chips">';
    caps.forEach(function (c) {
      var url = CAPCOLL[c] || (action + '?q=' + encodeURIComponent(c + ' btu') + '&type=product&filter.v.availability=1');
      out += '<a class="ms4l-ac__chip ms4l-ac__chip--pop" data-q="' + c + ' btu" href="' + url + '">' +
        c.toLocaleString('en-US') + ' BTU</a>';
    });
    terms.forEach(function (t) {
      out += '<a class="ms4l-ac__chip" data-q="' + esc(t) + '" href="' + action + '?q=' +
        encodeURIComponent(t) + '&type=product&filter.v.availability=1">' + esc(t) + '</a>';
    });
    out += '</div></div>';
    return out;
  }


  /* Shopify троттлит /search/suggest.json (429). Один повтор с паузой,
     и в любом случае показываем то, что успела отдать секция фасетов. */
  function getJSON(url, signal, tries) {
    tries = tries || 2;
    return fetch(url, { signal: signal }).then(function (r) {
      if (r.status === 429 && tries > 1) {
        return new Promise(function (res) { setTimeout(res, 450); })
          .then(function () { return getJSON(url, signal, tries - 1); });
      }
      if (!r.ok) return null;
      return r.json();
    }).catch(function () { return null; });
  }
  function getText(url, signal, tries) {
    tries = tries || 2;
    return fetch(url, { signal: signal }).then(function (r) {
      if (r.status === 429 && tries > 1) {
        return new Promise(function (res) { setTimeout(res, 450); })
          .then(function () { return getText(url, signal, tries - 1); });
      }
      if (!r.ok) return null;
      return r.text();
    }).catch(function () { return null; });
  }

  function AC(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.ms4lAc) return;
    form.dataset.ms4lAc = '1';
    var wrap = form.querySelector('.searchform--form') || form;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

    /* родной предиктив темы отключаем — иначе два поп-апа одновременно */
    var native = form.querySelector('.thb-predictive-search');
    if (native) { native.setAttribute('inert', ''); native.style.display = 'none'; }  /* НЕ remove() — ломает скрипт темы */
    /* слой темы для перехвата клика вне поиска блокировал всю страницу — отключаем,
       свой обработчик outside-click у нас есть */
    var cap = form.querySelector('.searchform--click-capture');
    if (cap) { cap.style.pointerEvents = 'none'; cap.style.display = 'none'; }

    /* точка монтирования зависит от ширины экрана:
       десктоп — контейнер шапки (поп-ап во всю ширину контента),
       мобильный — рядом с полем, иначе он уезжает за экран или попадает в скрытый контейнер */
    var MQ = window.matchMedia('(min-width: 1024px)');
    var wide = form.closest('.header--inner') || form.closest('theme-header');
    var box = document.createElement('div');
    box.className = 'ms4l-ac';

    function remount() {
      /* десктоп — карточка во всю ширину шапки.
         мобильный — НЕ отдельная карточка: выводим блоком внутрь шторки поиска,
         иначе получается «окно на окно» и позиция плывёт из-за transform шторки. */
      /* мобильный: кладём В ФОРМУ, а не в .searchform--form.
         Внутри wrap лежат абсолютные значок AI, крестик и лупа — они бы
         центрировались по всей высоте списка результатов. */
      var target = MQ.matches ? (wide || wrap) : (form.querySelector('.ms4l-msbar__form') ? form : (form || wrap));
      if (box.parentElement === target) return;
      target.appendChild(box);
      /* 06.08: .header--inner НЕ трогаем — inline position:relative превращал его
         в containing block для мега-меню, и у выпадающих панелей появлялись
         белые полосы по бокам (1320px вместо ширины окна). Широкий поп-ап
         вместо этого позиционируется fixed, координаты считает place(). */
      if (target !== wide && getComputedStyle(target).position === 'static') {
        target.style.position = 'relative';
      }
      if (target === wide) { target.style.removeProperty('position'); }
      box.classList.toggle('ms4l-ac--wide', MQ.matches && target === wide);
      box.classList.toggle('ms4l-ac--flat', !MQ.matches);
      box.style.top = '';
    }
    if (MQ.addEventListener) MQ.addEventListener('change', function () { remount(); place(); });
    box.id = 'ms4l-ac-' + Math.random().toString(36).slice(2, 8);
    box.setAttribute('role', 'listbox');
    remount();

    /* значок ИИ в поле — сигнал «умный поиск», сама подача честная: данные с сервера */
    if (!wrap.querySelector('.ms4l-aibadge')) {
      var bdg = document.createElement('span');
      bdg.className = 'ms4l-aibadge';
      bdg.innerHTML = '<svg class="" viewBox="0 0 24 24" fill="none" aria-hidden="true">'+'<path d="M12 2.6l1.7 4.6 4.6 1.7-4.6 1.7L12 15.2l-1.7-4.6L5.7 8.9l4.6-1.7L12 2.6z" fill="currentColor"/>'+'<path d="M18.6 14.4l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4z" fill="currentColor" opacity=".7"/></svg>' + 'AI';
      wrap.appendChild(bdg);
      wrap.classList.add('has-ai');
    }
    if (!input.dataset.ms4lPh && (!input.placeholder || /search/i.test(input.placeholder))) {
      input.placeholder = 'Describe what you need — 36,000 BTU, 3 zones, cassette\u2026';
    }

    /* type=search рисует свой крестик только при фокусе — CSS его не всегда берёт.
       Меняем на text: браузерного крестика не существует, остаётся только наш. */
    if (input.type === 'search') input.type = 'text';

    /* свой крестик сброса */
    if (!wrap.querySelector('.ms4l-clr')) {
      var clr = document.createElement('button');
      clr.type = 'button'; clr.className = 'ms4l-clr';
      clr.setAttribute('aria-label', 'Clear search');
      clr.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'+'<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
      clr.addEventListener('click', function () {
        input.value = ''; typed = ''; wrap.classList.remove('has-val');
        close(); input.focus();
      });
      wrap.appendChild(clr);
    }
    var syncClr = function () { wrap.classList.toggle('has-val', input.value.trim().length > 0); };
    input.addEventListener('input', syncClr); syncClr();
    /* блокируем уже на фокусе: прыжок наверх происходил до первого символа */
    input.addEventListener('focus', function () { ms4lLockScroll(true); });

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', box.id);

    var t = null, ctl = null, items = [], cur = -1, lastQ = '', typed = '';

    /* 06.08: пока поп-ап открыт, документ не скроллим.
       На мобильном поп-ап лежит в потоке и растил страницу (scrollY 14 -> 715),
       на ПК страницу кидало наверх при фокусе (400 -> 0). Блокируем overflow,
       а не position:fixed: fixed сдвигает точку отсчёта для sticky-шапки и
       самого поп-апа. Список остаётся достижимым — у поп-апа свой скролл. */
    /* 06.08: страница не должна ехать, пока идёт поиск.
       Поле лежит в sticky-шапке и визуально уже на экране, но браузер на каждое
       нажатие тянет каретку к его «неприлипшей» позиции у верха документа
       (моб 400 -> 240 -> 0, ПК 400 -> 4). Прокрутку не запрещаем: overflow:hidden
       на документе сам сбрасывает scrollY в 0. Держим позицию возвратом. */
    /* 06.08 (третья правка, жалоба «дёргается body при вводе»): гасить прокрутку
       возвратом — лечить симптом. Опыт на живой странице показал причину:
         шапка sticky  -> браузер уводит страницу на 333px за набор (225 кадров);
         шапка static  -> 0px;
         шапка fixed   -> 0px.
       То есть Chrome тянет каретку к «неприлипшей» позиции шапки. Поэтому пока
       открыт поиск, шапку фиксируем на её текущем месте и подставляем распорку
       той же высоты. Замерено: сдвига вёрстки нет (main не двинулся), панели
       мега-меню и scrollWidth совпадают на 1440 и 1100 — то есть containing block
       для абсолютных панелей не поменялся. Возврат позиции ниже оставлен
       страховкой на случай браузеров, которые всё-таки доскроллят. */
    var hdrEl = null, hdrPrev = null, hdrSpacer = null;
    function pinHeader(on) {
      try {
        if (on) {
          if (hdrSpacer) return;
          var h = document.querySelector('.header-section') ||
                  document.querySelector('.shopify-section-group-header-group');
          if (!h) return;
          var r = h.getBoundingClientRect();
          hdrEl = h;
          hdrPrev = h.getAttribute('style');
          hdrSpacer = document.createElement('div');
          hdrSpacer.className = 'ms4l-hdr-spacer';
          hdrSpacer.style.height = Math.round(r.height) + 'px';
          h.parentNode.insertBefore(hdrSpacer, h.nextSibling);
          h.style.setProperty('position', 'fixed', 'important');
          h.style.setProperty('top', Math.round(r.top) + 'px', 'important');
          h.style.setProperty('left', Math.round(r.left) + 'px', 'important');
          h.style.setProperty('width', Math.round(r.width) + 'px', 'important');
        } else {
          if (!hdrEl) return;
          if (hdrPrev === null) hdrEl.removeAttribute('style');
          else hdrEl.setAttribute('style', hdrPrev);
          if (hdrSpacer && hdrSpacer.parentNode) hdrSpacer.parentNode.removeChild(hdrSpacer);
          hdrEl = null; hdrSpacer = null; hdrPrev = null;
        }
      } catch (e) {}
    }
    /* при смене размера окна фиксированная шапка разъехалась бы — отпускаем */
    window.addEventListener('resize', function () { if (hdrSpacer) pinHeader(false); });

    var lockY = null, holdT = [], preY = null;
    function ms4lHoldScroll() {
      if (lockY === null) return;
      if (Math.abs((window.scrollY || 0) - lockY) > 2) window.scrollTo(0, lockY);
    }
    /* перезаряжаем на каждое нажатие: анимация стартует заново с каждым символом */
    function ms4lArm() {
      holdT.forEach(clearTimeout); holdT = [];
      ms4lHoldScroll();
      requestAnimationFrame(ms4lHoldScroll);
      /* с мгновенной прокруткой хватает пары проверок: раньше шесть таймеров
         до 700ms продолжали дёргать позицию всё время анимации */
      [0, 40, 120].forEach(function (ms) {
        holdT.push(setTimeout(ms4lHoldScroll, ms));
      });
    }
    function ms4lLockScroll(on, restore) {
      try {
        var de = document.documentElement, bd = document.body;
        if (on) {
          if (lockY === null) lockY = preY !== null ? preY : (window.scrollY || 0);
          pinHeader(true);
          de.classList.add('ms4l-noscroll');
          bd.classList.add('ms4l-noscroll');
          ms4lArm();
        } else {
          holdT.forEach(clearTimeout); holdT = [];
          pinHeader(false);
          de.classList.remove('ms4l-noscroll');
          bd.classList.remove('ms4l-noscroll');
          /* при отпускании по фокусу возвращаем позицию: хвост браузерной
             анимации иначе докатывался до нуля (после Esc кидало в самый верх).
             При намеренной прокрутке (колесо/свайп) restore не передаём. */
          if (restore && lockY !== null) {
            var y = lockY;
            if (Math.abs((window.scrollY || 0) - y) > 2) window.scrollTo(0, y);
            [30, 120, 300].forEach(function (ms) {
              setTimeout(function () {
                if (Math.abs((window.scrollY || 0) - y) > 2) window.scrollTo(0, y);
              }, ms);
            });
          }
          lockY = null; preY = null;
        }
      } catch (e) {}
    }
    /* позицию пользователя снимаем ДО фокуса: в обработчике focus уже поздно */
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (lockY === null) preY = window.scrollY || 0;
      }, true);
    });
    /* keydown приходит раньше, чем браузер запланирует прокрутку каретки */
    input.addEventListener('keydown', function () {
      if (lockY === null) { preY = window.scrollY || 0; ms4lLockScroll(true); }
      else ms4lArm();
    }, true);
    /* ушли из поля — отпускаем */
    input.addEventListener('blur', function () { setTimeout(function () {
      if (document.activeElement !== input) ms4lLockScroll(false, true);
    }, 60); });
    /* намеренную прокрутку не мешаем: колесо или свайп вне поп-апа отпускает */
    ['wheel', 'touchmove'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (lockY === null) return;
        var t = e.target;
        if (!(t && t.closest && t.closest('.ms4l-ac'))) ms4lLockScroll(false);
      }, { passive: true, capture: true });
    });
    window.addEventListener('scroll', function () {
      if (lockY !== null && box.classList.contains('is-open')) ms4lHoldScroll();
    }, { passive: true });
    function close() {
      /* удержание тут НЕ снимаем: модуль зовёт close() между запросами, и на
         каждом снятии страница успевала проехать — дрейф накапливался по 8px
         на символ. Граница — фокус в поле, см. blur ниже. */
      box.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant'); cur = -1; items = [];
    }
    /* ставим поп-ап ровно под строку поиска, а не под всю шапку */
    function place() {
      if (box.classList.contains('ms4l-ac--flat')) {
        box.style.top = '';
        /* 06.08: поп-ап лежит внутри sticky-шапки и вместе со страницей почти
           не едет, поэтому низ списка был недостижим. Даём ему собственную
           высоту по видимой части экрана; visualViewport учитывает клавиатуру.
           Пишем в CSS-переменную, а не в style.maxHeight: во flat-блоке стоит
           max-height:none !important, инлайн-стиль его не перебивает. */
        var vv = window.visualViewport;
        var vh = (vv && vv.height) || window.innerHeight;
        var topY = box.getBoundingClientRect().top;
        box.style.setProperty('--ms4l-acmax', Math.max(260, Math.round(vh - topY - 10)) + 'px');
        return;
      }
      box.style.removeProperty('--ms4l-acmax');
      var ir = input.getBoundingClientRect();
      if (!box.classList.contains('ms4l-ac--wide') && getComputedStyle(box).position === 'fixed') {
        /* мобильный: поп-ап во всю ширину экрана, координата от вьюпорта */
        box.style.top = Math.round(ir.bottom + 8) + 'px';
        return;
      }
      if (box.classList.contains('ms4l-ac--wide')) {
        /* fixed, поэтому координаты от вьюпорта: по горизонтали равняемся на
           .header--inner, чтобы поп-ап стоял там же, где стоял раньше */
        var hr = (wide || box.parentElement).getBoundingClientRect();
        box.style.left = Math.round(hr.left) + 'px';
        box.style.width = Math.round(hr.width) + 'px';
        box.style.top = Math.round(ir.bottom + 8) + 'px';
        return;
      }
      if (box.parentElement === wrap) { box.style.top = ''; return; }
      var mr = box.parentElement.getBoundingClientRect();
      box.style.top = Math.round(ir.bottom - mr.top + 8) + 'px';
    }
    function open() {
      ms4lLockScroll(true);
      place();
      box.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
      /* шторка поиска на мобильном выезжает с анимацией — позицию берём ещё раз, когда она села */
      requestAnimationFrame(place);
      setTimeout(place, 260);
      setTimeout(place, 520);
    }
    window.addEventListener('resize', function () { if (box.classList.contains('is-open')) place(); });
    window.addEventListener('scroll', function () { if (box.classList.contains('is-open')) place(); }, { passive: true });
    if (window.visualViewport) {
      /* клавиатура открылась/закрылась — пересчитываем высоту списка */
      var vvRe = function () { if (box.classList.contains('is-open')) place(); };
      window.visualViewport.addEventListener('resize', vvRe);
      window.visualViewport.addEventListener('scroll', vvRe);
    }

    function mark(n) {
      items.forEach(function (el) { el.classList.remove('is-cur'); el.setAttribute('aria-selected', 'false'); });
      cur = n;
      if (n < 0 || !items[n]) { input.removeAttribute('aria-activedescendant'); input.value = typed; return; }
      var el = items[n];
      el.classList.add('is-cur'); el.setAttribute('aria-selected', 'true');
      el.scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', el.id);
      /* копируем активную подсказку в поле — 58% сайтов этого не делают */
      if (el.dataset.q) input.value = el.dataset.q;
    }

    /* 20.08: топ живых запросов за 30 дней по числу ЛЮДЕЙ (GA4, боты отсечены).
       Показываются на пустом фокусе: раньше новичку без истории панель вообще
       не открывалась. Порядок = популярность. */
    /* Bravo в списке не по популярности, а по решению магазина: продвигаем бренд */
    var POPULAR = ['60,000 BTU', '18,000 BTU', '12,000 BTU', '36,000 BTU', '24,000 BTU', '6,000 BTU', 'Cooper & Hunter', 'Bravo'];
    function intro() {
      var rc = recent();
      var act = form.getAttribute('action') || '/search';
      var h = '';
      if (rc.length) {
        h += '<div class="ms4l-ac__seg"><div class="ms4l-ac__h">Recent searches</div><div class="ms4l-ac__chips">';
        rc.forEach(function (t) {
          h += '<a class="ms4l-ac__chip" data-q="' + esc(t) + '" href="' + esc(act) +
            '?q=' + encodeURIComponent(t) + '&type=product&filter.v.availability=1">' + esc(t) + '</a>';
        });
        h += '</div></div>';
      }
      h += '<div class="ms4l-ac__seg"><div class="ms4l-ac__h">Popular searches</div><div class="ms4l-ac__chips">';
      POPULAR.forEach(function (t) {
        h += '<a class="ms4l-ac__chip ms4l-ac__chip--live" data-q="' + esc(t) + '" href="' + esc(act) +
          '?q=' + encodeURIComponent(t) + '&type=product&filter.v.availability=1">' + esc(t) + '</a>';
      });
      h += '</div></div>';
      /* 21.08: тихий ряд ВСЕХ мощностей в наличии (из ZONECAP — только системы,
         только in-stock): шесть популярных чипов выше читались как «это всё,
         что есть». Ряд нарочно приглушён — мелкие чипы без рамки. */
      var sizes = Object.keys(ZONECAP).map(Number).sort(function (a, b) { return a - b; });
      if (sizes.length) {
        h += '<div class="ms4l-ac__seg ms4l-ac__seg--sizes"><div class="ms4l-ac__h">All sizes, BTU</div><div class="ms4l-ac__chips">';
        sizes.forEach(function (c) {
          var qv = c.toLocaleString('en-US') + ' BTU';
          h += '<a class="ms4l-ac__chip ms4l-ac__chip--live ms4l-ac__chip--size" data-q="' + qv + '" href="' + esc(act) +
            '?q=' + encodeURIComponent(qv) + '&type=product&filter.v.availability=1">' + (c / 1000) + 'K</a>';
        });
        h += '</div></div>';
      }
      /* 21.08: те же тихие ряды — зоны и бренды */
      var quietRow = function (title, list) {
        h += '<div class="ms4l-ac__seg ms4l-ac__seg--sizes"><div class="ms4l-ac__h">' + title + '</div><div class="ms4l-ac__chips">';
        list.forEach(function (it) {
          h += '<a class="ms4l-ac__chip ms4l-ac__chip--live ms4l-ac__chip--size" data-q="' + esc(it.q) + '" href="' + esc(act) +
            '?q=' + encodeURIComponent(it.q) + '&type=product&filter.v.availability=1">' + esc(it.t) + '</a>';
        });
        h += '</div></div>';
      };
      quietRow('Zones', [
        { t: 'Single Zone', q: 'single zone' }, { t: 'Dual Zone', q: '2 zone' },
        { t: '3 Zones', q: '3 zone' }, { t: '4 Zones', q: '4 zone' },
        { t: '5 Zones', q: '5 zone' }, { t: '6 Zones', q: '6 zone' }
      ]);
      quietRow('Brands', [
        { t: 'Cooper & Hunter', q: 'Cooper & Hunter' }, { t: 'Bravo', q: 'Bravo' },
        { t: 'OLMO', q: 'OLMO' }, { t: 'Armbridge', q: 'Armbridge' }
      ]);
      box.innerHTML = h;
      items = [].slice.call(box.querySelectorAll('.ms4l-ac__chip'));
      items.forEach(function (el, i) { el.id = box.id + '-r' + i; el.setAttribute('role', 'option'); });
      /* клик по популярному — живая выдача прямо в панели, без перехода:
         именно в панели работают бестселлеры, зоны и бейджи продаж */
      box.querySelectorAll('.ms4l-ac__chip--live').forEach(function (el) {
        el.addEventListener('click', function (ev) {
          ev.preventDefault();
          var t = el.dataset.q || '';
          trk('ms4l_search_popular', { search_term: t });
          input.value = t;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        });
      });
      cur = -1;
      open();
    }

    function skeleton(q) {
      box.innerHTML =
        '<div class="ms4l-ac__scan">' + '<svg class="ms4l-ac__spark" viewBox="0 0 24 24" fill="none" aria-hidden="true">'+'<path d="M12 2.6l1.7 4.6 4.6 1.7-4.6 1.7L12 15.2l-1.7-4.6L5.7 8.9l4.6-1.7L12 2.6z" fill="currentColor"/>'+'<path d="M18.6 14.4l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4z" fill="currentColor" opacity=".7"/></svg>' +
        '<span>Reading <strong>5,449</strong> products for &ldquo;' + esc(q) + '&rdquo;</span>' +
        '<span class="ms4l-ac__typing"><i></i><i></i><i></i></span></div>' +
        '<div class="ms4l-ac__sk"><div class="ms4l-ac__skr"></div><div class="ms4l-ac__skr"></div>' +
        '<div class="ms4l-ac__skr"></div><div class="ms4l-ac__skr"></div></div>';
      open();
    }

  var bestCache = {}, lastR = null;
    function loadBest(cap) {
      bestCache[cap] = null;                       /* загрузка пошла */
      Promise.all((BESTCAP[cap] || []).map(function (e) {
        return fetch('/products/' + e.h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.available) return null;   /* sold out в топ не подмешиваем */
            var img = p.featured_image || (p.images && p.images[0]) || '';
            if (img && img.indexOf('?') === -1) img += '?width=128';
            return { handle: e.h, prod: { title: p.title, url: '/products/' + e.h,
              featured_image: { url: img }, image: img,
              price: p.price / 100, compare_at_price_min: (p.compare_at_price || 0) / 100,
              available: p.available, sold: e.s, ptype: p.type || '' } };
          }).catch(function () { return null; });
      })).then(function (rs) {
        bestCache[cap] = rs.filter(Boolean);
        if (lastR && wantedBtu(lastR.q) === cap) render(lastR.q, lastR.sug, lastR.fac);
      });
    }
    function render(q, sug, fac) {
      var types = (fac && fac.types) || [], brands = (fac && fac.brands) || [];
      var srv = (fac && fac.products) || [];
      var allp = srv.length ? srv.map(function (p) {
        return { title: p.title, url: p.url, featured_image: { url: p.img }, image: p.img,
                 price: p.price, compare_at_price_min: p.cap, available: p.available,
                 sold: p.sold || 0, ptype: p.type || '',
                 sku: p.sku || '', skus: p.skus || '' };
      }) : (sug.products || []).filter(function (p) { return p.available !== false; })
          .map(function (p) {                       /* у suggest SKU лежат в variants */
            if (!p.skus) p.skus = (p.variants || []).map(function (v) { return v.sku || ''; }).join(' ');
            return p;
          });
      var need = wantedBtu(q), dropped = 0;
      lastR = { q: q, sug: sug, fac: fac };
      /* бестселлеры мощности, не доехавшие в топ-250 выдачи */
      if (need && BESTCAP[need] && !isPartQuery(q)) {
        if (bestCache[need] === undefined) loadBest(need);
        else if (bestCache[need]) {
          bestCache[need].forEach(function (b) {
            var dup = allp.some(function (p) {
              return String(p.url || '').split('?')[0].indexOf('/products/' + b.handle) > -1;
            });
            if (!dup) allp.push(b.prod);
          });
        }
      }
      var isPart = isPartQuery(q), partHidden = 0, partExactN = 0;
      if (isPart) {
        /* 15.09: раньше неточные выбрасывались и выдача была пустой, даже когда
           товары нашлись. Теперь точные помечаем флагом и держим сверху,
           остальные показываем ниже отдельным блоком. */
        allp.forEach(function (p) { p._xp = exactPart(p, q) ? 1 : 0; });
        partExactN = allp.filter(function (p) { return p._xp; }).length;
        need = null;                     /* правило по BTU к запчастям не применяем */
      }
      var otherCap = [];
      if (need) {
        var exact = allp.filter(function (p) { return titleHasBtu(p.title, need); });
        dropped = allp.length - exact.length;
        if (exact.length) {
          /* точная мощность сверху; остальные мощности — ниже, отдельным блоком,
             чтобы список не обрывался на пяти позициях */
          otherCap = allp.filter(function (p) { return !titleHasBtu(p.title, need); });
          allp = exact;
        }
        /* если точного нет — оставляем выдачу как есть, но честно предупреждаем */
        else if (srv.length) { allp = srv.map(function (p) {
          return { title: p.title, url: p.url, featured_image: { url: p.img }, image: p.img,
                   price: p.price, compare_at_price_min: p.cap, available: p.available, sold: p.sold || 0, ptype: p.type || '',
                   sku: p.sku || '', skus: p.skus || '' }; }); }
        else allp = [];
      }
      /* 06.08: число зон названо в запросе — товары с другим числом зон
         уводим в хвост. Если так остаётся меньше 3 позиций, не фильтруем:
         пустая выдача хуже неточной. */
      var wz = wantedZones(q);
      if (wz) {
        var zok = [], zbad = [];
        allp.forEach(function (p) {
          var z = zoneOf(p.title);
          (z === 0 || z === wz ? zok : zbad).push(p);
        });
        if (zok.length >= 3) { allp = zok; otherCap = zbad.concat(otherCap); }
      }
      /* топ выдача: наличие -> продажи -> глубина скидки */
      allp.sort(function (a, b) {
        var xp = ((b._xp || 0) - (a._xp || 0)) * 1e9;   /* точные совпадения всегда первыми */
        return xp || ((pscore(b) - catPen(b, q)) - (pscore(a) - catPen(a, q)));
      });
      otherCap.sort(function (a, b) { return (pscore(b) - catPen(b, q)) - (pscore(a) - catPen(a, q)); });
      var exactN = Math.min(allp.length, LIMP);
      var prods = allp.slice(0, LIMP);
      if (prods.length < LIMP && otherCap.length) {
        prods = prods.concat(otherCap.slice(0, LIMP - prods.length));
      }
      var qs = isPartQuery(q) ? [] : (sug.queries || []).filter(function (s) { return String(s.text || '').toLowerCase().trim() !== q.toLowerCase().trim(); }).slice(0, LIMQ);
      var cols = (sug.collections || []).slice(0, LIMC);
      var total = (fac && fac.total) || 0;
      trkSearch(q, total, isPart, typeof wz === 'number' ? wz : 0);

      if (!prods.length && !types.length && !cols.length) {
        box.innerHTML = '<div class="ms4l-ac__scan">' + '<svg class="ms4l-ac__spark" viewBox="0 0 24 24" fill="none" aria-hidden="true">'+'<path d="M12 2.6l1.7 4.6 4.6 1.7-4.6 1.7L12 15.2l-1.7-4.6L5.7 8.9l4.6-1.7L12 2.6z" fill="currentColor"/>'+'<path d="M18.6 14.4l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4z" fill="currentColor" opacity=".7"/></svg>' +
          '<span>No match for &ldquo;' + esc(q) + '&rdquo;</span></div>' +
          '<div class="ms4l-ac__empty"><strong>Nothing matched exactly</strong>' +
          '<div style="margin-top:4px">Here is the closest we carry.</div></div>' +
          sugChips(q, wantedBtu(q), form.getAttribute('action') || '/search');
        open(); items = []; return;
      }

      var h = '<div class="ms4l-ac__scan"><span class="ms4l-ac__live"></span>' +
        (total ? '<span>Matched <strong>' + total.toLocaleString('en-US') + '</strong> products</span>' : '<span>Results</span>') +
        (types.length ? '<span>&middot; ' + types.length + ' categories</span>' : '') +
        (brands.length ? '<span>&middot; ' + brands.length + ' brands</span>' : '') + '</div>';

      var action = form.getAttribute('action') || '/search';
      var allUrl = action + '?q=' + encodeURIComponent(q) + '&type=product&filter.v.availability=1';
      /* на телефоне список длинный, поэтому переход на страницу результатов — сразу наверху */
      if (!MQ.matches) {
        h += '<a class="ms4l-ac__alltop" href="' + esc(allUrl) + '">' +
          'See all' + (total ? ' ' + total.toLocaleString('en-US') : '') + ' results &rarr;</a>';
      }
      /* на телефоне по умолчанию открыты ТОВАРЫ — категории и бренды человек откроет сам */
      var defPane = MQ.matches ? 0 : 1;
      h += '<div class="ms4l-ac__tabs" role="tablist">' +
        '<button type="button" class="ms4l-ac__tab" role="tab" aria-selected="' + (defPane === 0) + '" data-tab="0">Categories</button>' +
        '<button type="button" class="ms4l-ac__tab" role="tab" aria-selected="' + (defPane === 1) + '" data-tab="1">Products</button>' +
        '<button type="button" class="ms4l-ac__tab" role="tab" aria-selected="' + (defPane === 2) + '" data-tab="2">Brands</button></div>';

      h += '<div class="ms4l-ac__cols">';

      /* 1. КАТЕГОРИИ — по объёму, крупнейшая первой */
      h += '<div class="ms4l-ac__col" data-pane="0"' + (defPane === 0 ? '' : ' hidden') + '><div class="ms4l-ac__h">Categories</div>';
      if (types.length) {
        types.slice().sort(byTierCount).forEach(function (v) {
          h += '<a class="ms4l-ac__it ms4l-ac__type" href="' + esc(v.url) + '">' +
            tico(v.label, null) +
            '<span class="ms4l-ac__nm">' + esc(v.label) + '</span>' +
            '<span class="ms4l-ac__ct">' + v.count + '</span></a>';
        });
      }
      cols.forEach(function (c) {
        var ti = typeImg(c.title);
      /* 18.09.2026: сначала ровная иконка типа, обложка коллекции — только если совпадения нет.
         Обложки у нас баннерные (2500x893) и в квадрате 38px смотрелись инородно. */
      var ci = (c.featured_image && c.featured_image.url) || c.image;
        h += '<a class="ms4l-ac__it ms4l-ac__type" href="' + esc(c.url) + '">' + tico(c.title, ci) +
          '<span class="ms4l-ac__nm">' + esc(c.title) + '</span></a>';
      });
      if (!types.length && !cols.length) h += '<div class="ms4l-ac__hint">No category match</div>';
      if (qs.length) {
        h += '<div class="ms4l-ac__h" style="padding-top:10px">Suggestions</div>';
        qs.forEach(function (s) {
          h += '<a class="ms4l-ac__it ms4l-ac__q" data-q="' + esc(s.text) + '" href="' + esc(s.url) +
            '"><span class="ms4l-ac__nm">' + hl(s.text, q) + '</span></a>';
        });
      }
      h += '</div>';

      /* 2. ТОВАРЫ */
      h += '<div class="ms4l-ac__col" data-pane="1"' + (defPane === 1 ? '' : ' hidden') + '><div class="ms4l-ac__h">' +
        (prods.length ? 'Top picks for &ldquo;' + esc(q) + '&rdquo;' : 'Products') + '</div>';
      if (need && !isPart && CAPS.indexOf(need) === -1) {
        h += sugChips(q, need, form.getAttribute('action') || '/search');
      }
      if (isPart && prods.length) {
        h += partExactN
          ? '<div class="ms4l-ac__note ms4l-ac__note--part"><strong>Exact part match</strong> for ' + esc(q) + '.</div>'
          : '<div class="ms4l-ac__note ms4l-ac__note--part">No exact match for <strong>' + esc(q) +
            '</strong> \u2014 showing products that contain this part number.</div>';
      }
      if (isPart && !prods.length) {
        h += '<div class="ms4l-ac__note ms4l-ac__note--part">No part matches <strong>' + esc(q) + '</strong> exactly.' +
          '<br>Call <a href="tel:+18557754822">(855) 775-4822</a> \u2014 we will identify it by your model number.</div>';
      }
      if (!isPart && prods.length && need && !titleHasBtu(prods[0].title, need)) {
        h += '<div class="ms4l-ac__note">Showing closest matches \u2014 no exact <strong>' +
          need.toLocaleString('en-US') + ' BTU</strong> product in the top results.</div>';
      }
      if (prods.length) {
        prods.forEach(function (p, pi) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var av = p.available;
          var pr = p.price != null ? money(p.price) : '';
          var cap = parseFloat(p.compare_at_price_min || p.compare_at_price_max || 0);
          var pnum = parseFloat(p.price || 0);
          var cmp = cap > pnum ? '<s>' + money(cap) + '</s>' : '';
          if (isPart && partExactN && pi === partExactN) {
            h += '<div class="ms4l-ac__h ms4l-ac__h--more">Contains this part number</div>';
          } else if (!isPart && pi === TOPN && exactN > TOPN) {
            h += '<div class="ms4l-ac__h ms4l-ac__h--more">More matches</div>';
          }
          if (need && pi === exactN && otherCap.length) {
            h += '<div class="ms4l-ac__h ms4l-ac__h--more">Other capacities</div>';
          }
          h += '<a class="ms4l-ac__p' + (pi < TOPN ? ' is-top' : '') + '" href="' + esc(p.url) + '">' +
            (img ? '<img class="ms4l-ac__img" src="' + esc(img) + '&width=92" alt="" loading="lazy">' : '<span class="ms4l-ac__img"></span>') +
            '<span class="ms4l-ac__pb"><span class="ms4l-ac__pt">' + esc(p.title) + '</span>' +
            '<span class="ms4l-ac__pm"><span class="ms4l-ac__pr">' + cmp + pr + '</span>' +
            '<span class="' + (av ? 'ms4l-ac__ok' : 'ms4l-ac__oos') + '">' + (av ? 'In stock' : 'Sold out') + '</span>' +
            (pi < TOPN ? '<span class="ms4l-ac__hot">&#9733; Top pick</span>' : '') +
            ((p.sold || 0) >= 5 ? '<span class="ms4l-ac__sold">' + p.sold + ' sold</span>' : '') +
            '</span></span></a>';
        });
      } else if (need && !isPart) {
        h += '<div class="ms4l-ac__note">No exact <strong>' + need.toLocaleString('en-US') +
          ' BTU</strong> match. Pick a category on the left \u2014 counts are exact.</div>';
      } else h += '<div class="ms4l-ac__hint">No product match</div>';
      h += '</div>';

      /* 3. БРЕНДЫ */
      h += '<div class="ms4l-ac__col" data-pane="2"' + (defPane === 2 ? '' : ' hidden') + '><div class="ms4l-ac__h">Brands</div>';
      if (brands.length) {
        brands.slice().sort(function (a, b) { return b.count - a.count; }).forEach(function (v) {
          var lg = logoFor(v.label), base = lg ? lg.split('?')[0] : '';
          h += '<a class="ms4l-ac__it ms4l-ac__brand" href="' + esc(v.url) + '" title="' + esc(v.label) + '">' +
            (lg
              ? '<span class="ms4l-ac__blwrap"><img class="ms4l-ac__blogo" alt="' + esc(v.label) + '" loading="lazy" ' +
                'src="' + esc(base) + '?width=200" srcset="' + esc(base) + '?width=200 1x, ' + esc(base) + '?width=400 2x"></span>' +
                '<span class="visually-hidden">' + esc(v.label) + '</span>'
              : '<span class="ms4l-ac__nm">' + esc(v.label) + '</span>') +
            '<span class="ms4l-ac__ct">' + v.count + '</span></a>';
        });
      } else h += '<div class="ms4l-ac__hint">No brand match</div>';

      /* 20.08: Zones — блоком под брендами. Точных счётчиков нет: фильтр по зонам
         в Search & Discovery не настроен, поэтому зону берём из заголовков
         загруженных товаров и показываем только те, что реально есть в выдаче.
         Клик уточняет запрос: «60000» -> «60000 2 zone» (ранжирование по зонам
         в поп-апе уже есть). К запчастям блок не относится. */
      if (!isPart) {
        /* мощность названа в запросе -> зоны из карты каталога (полная правда);
           иначе -> по загруженным товарам (там счёт неполный, но зон без товаров не покажет) */
        var zlist;
        if (need && ZONECAP[need]) {
          zlist = ZONECAP[need].slice();
        } else {
          var zcnt = {};
          allp.concat(otherCap).forEach(function (p) {
            var z = zoneOf(p.title); if (z) zcnt[z] = (zcnt[z] || 0) + 1;
          });
          zlist = Object.keys(zcnt).map(Number).sort(function (a, b) { return a - b; });
        }
        if (zlist.length > 1 || (zlist.length === 1 && wz && zlist[0] !== wz)) {
          var zbase = q.replace(/\b(single|one|two|dual|three|tri|four|quad|five|six)[\s-]?zones?\b/gi, ' ')
                       .replace(/\b\d[\s-]?zones?\b/gi, ' ').replace(/\bsingle\b/gi, ' ')
                       .replace(/\s+/g, ' ').trim();
          h += '<div class="ms4l-ac__h ms4l-ac__zh">Zones</div><div class="ms4l-ac__chips ms4l-ac__zones">';
          zlist.forEach(function (z) {
            var lbl = z === 1 ? 'Single Zone' : (z === 2 ? 'Dual Zone' : z + ' Zones');
            var zq = (zbase ? zbase + ' ' : '') + (z === 1 ? 'single zone' : z + ' zone');
            h += '<a class="ms4l-ac__chip ms4l-ac__zchip' + (wz === z ? ' is-on' : '') + '" data-q="' + esc(zq) +
              '" href="' + esc(action) + '?q=' + encodeURIComponent(zq) + '&type=product&filter.v.availability=1">' + lbl + '</a>';
          });
          h += '</div>';
        }
      }
      h += '</div></div>';

      h += '<a class="ms4l-ac__all" href="' + esc(form.getAttribute('action') || '/search') + '?q=' +
        encodeURIComponent(q) + '&type=product&filter.v.availability=1">See all' + (total ? ' ' + total.toLocaleString('en-US') : '') +
        ' results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';

      box.innerHTML = h;
      items = [].slice.call(box.querySelectorAll('.ms4l-ac__it,.ms4l-ac__p,.ms4l-ac__all'));
      /* 06.08: клик по товару из поиска — событие + атрибут корзины для привязки заказа */
      box.querySelectorAll('.ms4l-ac__p').forEach(function (el, pi) {
        el.addEventListener('click', function () {
          var nm = (el.querySelector('.ms4l-ac__pt') || el).textContent || '';
          trk('ms4l_search_click', { search_term: q, item_name: nm.replace(/\s+/g, ' ').trim().slice(0, 90),
                                     position: pi + 1, results: total || 0 });
          trkCart(q);
        }, { passive: true });
      });
      box.querySelectorAll('.ms4l-ac__all,.ms4l-ac__alltop').forEach(function (el) {
        el.addEventListener('click', function () {
          trk('ms4l_search_all', { search_term: q, results: total || 0 });
        }, { passive: true });
      });
      items.forEach(function (el, i) { el.id = box.id + '-o' + i; el.setAttribute('role', 'option'); el.setAttribute('aria-selected', 'false'); });
      cur = -1;
      box.querySelectorAll('.ms4l-ac__tab').forEach(function (b) {
        b.addEventListener('click', function () {
          box.querySelectorAll('.ms4l-ac__tab').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
          box.querySelectorAll('.ms4l-ac__col').forEach(function (c) { c.hidden = c.dataset.pane !== b.dataset.tab; });
        });
      });
      open();
    }

    function run(q) {
      if (ctl) ctl.abort();
      ctl = new AbortController();
      var sig = ctl.signal;
      skeleton(q);
      var u1 = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku';
      /* 20.08: sold out исключён из поиска целиком — фильтр наличия Shopify.
         Он же пересчитывает счётчики брендов/категорий: бренд, у которого
         в наличии ничего нет, из списка исчезает сам. */
      var u2 = '/search?q=' + encodeURIComponent(q) + '&type=product&filter.v.availability=1&section_id=ms4l-search-facets';
      Promise.all([getJSON(u1, sig), getText(u2, sig)]).then(function (res) {
        if (sig.aborted) return;
        var sug = (res[0] && res[0].resources && res[0].resources.results) || {};
        var fac = null;
        if (res[1]) {
          try {
            var d = new DOMParser().parseFromString(res[1], 'text/html');
            var n = d.getElementById('ms4l-facets-data');
            if (n) fac = JSON.parse(n.textContent);
          } catch (e) {}
        }
        render(q, sug, fac);
      });
    }

    input.addEventListener('input', function () {
      typed = input.value;
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < MIN) { lastQ = ''; intro(); return; }
      if (q === lastQ) return;
      t = setTimeout(function () { lastQ = q; run(q); }, DEB);
    });
    input.addEventListener('focus', function () {
      var v = input.value.trim();
      if (v.length >= MIN) { if (items.length) open(); else { lastQ = v; run(v); } }
      else intro();
    });
    form.addEventListener('submit', function () { pushRecent(input.value); });
    box.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-q], .ms4l-ac__all, .ms4l-ac__q');
      if (a) pushRecent(a.dataset.q || input.value);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.value = typed; return; }
      if (!box.classList.contains('is-open') || !items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(cur + 1 >= items.length ? -1 : cur + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(cur - 1 < -1 ? items.length - 1 : cur - 1); }
      else if (e.key === 'Enter' && cur > -1) { e.preventDefault(); items[cur].click(); }
    });
    /* 01.09: убрали клавиатуру — панель подсказок уходит и прокрутка отпускается.
       Раньше close() звался только по клику вне поля и по Escape, а .ms4l-noscroll
       снимался только в blur. Если клавиатуру убирали жестом без blur, панель
       висела на весь экран, а документ оставался заблокированным. */
    var ms4lKbClose = (function () {
      var touching = 0;
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
        box.addEventListener(ev, function () { touching = 1; }, true);
      });
      ['pointerup', 'touchend', 'touchcancel', 'mouseup'].forEach(function (ev) {
        document.addEventListener(ev, function () {
          if (touching === 1) { touching = 2; setTimeout(function () { if (touching === 2) touching = 0; }, 400); }
        }, true);
      });
      return function () {
        /* палец работает внутри панели — это тап по подсказке или прокрутка
           списка, которая на iOS сама убирает клавиатуру. Не мешаем. */
        if (touching) return;
        if (document.activeElement === input) return;
        if (!box.classList.contains('is-open')) { ms4lLockScroll(false, true); return; }
        close();
        ms4lLockScroll(false, true);
      };
    })();
    input.addEventListener('blur', function () { setTimeout(ms4lKbClose, 140); });
    if (window.visualViewport) {
      var vvH = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', function () {
        var h = window.visualViewport.height, grew = h - vvH; vvH = h;
        /* 120px: клавиатура 250-330px, схлопывание адресной строки 60-90px */
        if (grew > 120) setTimeout(ms4lKbClose, 60);
      });
    }
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !box.contains(e.target)) close(); });
  }

  /* добор счётчиков там, где выдача выше потолка 1000 и search.filters пуст */
  function fillCounts() {
    var hosts = [].slice.call(document.querySelectorAll('.ms4l-sr__capped [data-needs-counts]'));
    if (!hosts.length) return;
    var terms = document.querySelector('.ms4l-sr').dataset.terms || '';
    var tabs = [];
    hosts.forEach(function (h) {
      var param = h.dataset.param || 'filter.p.product_type';
      h.querySelectorAll('.is-pending').forEach(function (t) { t.dataset.param = param; tabs.push(t); });
    });
    var i = 0;
    function next() {
      var tab = tabs[i++];
      if (!tab) return;
      var v = tab.dataset.val;
      fetch('/search?q=' + encodeURIComponent(terms) + '&type=product&filter.v.availability=1&' + tab.dataset.param + '=' +
        encodeURIComponent(v) + '&section_id=ms4l-search-count')
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var m = String(txt).replace(/<[^>]*>/g, '').trim().match(/\d[\d,]*/);
          var n = m ? parseInt(m[0].replace(/,/g, ''), 10) : 0;
          var s = tab.querySelector('[data-n]');
          if (n > 0) { if (s) s.textContent = n; tab.classList.remove('is-pending'); }
          else tab.remove();
        })
        .catch(function () { tab.remove(); })
        .finally(next);
    }
    for (var k = 0; k < 3; k++) next();
  }

  /* на /search тема рисует ВТОРОЕ поле поиска и свой счётчик результатов —
     оставляем один поиск и один счётчик (наш, рядом с табами) */
  function dedupeSearchPage() {
    if (!/\/search/.test(location.pathname)) return;
    var host = document.querySelector('.template-header--content');
    if (!host) return;
    host.querySelectorAll('form[action*="/search"]').forEach(function (f) {
      var box = f.closest('search-form') || f;
      box.style.display = 'none';
      box.setAttribute('aria-hidden', 'true');
    });
    var d = document.querySelector('.template-header--description');
    if (d && /results?\s+found\s+for/i.test(d.textContent || '')) d.style.display = 'none';
    /* третий счётчик — в панели фасетов темы («1000 results»); наш уже стоит у табов */
    document.querySelectorAll('.facets-bar *, [class*="facets"] *, [class*="product-count"]').forEach(function (e) {
      if (e.children.length === 0 && /^\s*[\d,]+\s+results?\s*$/i.test(e.textContent || '')) {
        var w = e.closest('[class*="count"]') || e;
        w.style.display = 'none';
      }
    });
  }


  /* --- панель фильтров поиска: шторка на мобильном, «Show all N», сортировка --- */
  function facets() {
    var panel = document.querySelector('[data-ms4l-facets]');
    if (!panel || panel.dataset.ms4lReady) return;
    panel.dataset.ms4lReady = '1';
    var scrim = document.querySelector('.ms4l-fx__scrim');
    var opener = document.querySelector('[data-ms4l-facets-open]');
    function openP() {
      panel.classList.add('is-open'); if (scrim) scrim.hidden = false;
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }
    function closeP() {
      panel.classList.remove('is-open'); if (scrim) scrim.hidden = true;
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
    }
    if (opener) {
      opener.addEventListener('click', openP);
      /* кнопка стоит над сеткой товаров, а не внутри контейнера сайдбара */
      var grid = document.getElementById('product-grid') || document.querySelector('#ProductGridContainer');
      if (grid && grid.parentElement) grid.parentElement.insertBefore(opener, grid);
      /* группы фильтров прокручиваем отдельным контейнером */
      var body = document.createElement('div');
      body.className = 'ms4l-fx__body';
      var move = panel.querySelectorAll('.ms4l-fx__applied, .ms4l-fx__sort, .ms4l-fx__g');
      if (move.length) {
        panel.insertBefore(body, move[0]);
        move.forEach(function (el) { body.appendChild(el); });
      }
    }
    document.querySelectorAll('[data-ms4l-facets-close]').forEach(function (b) {
      b.addEventListener('click', closeP);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeP(); });
    /* «Show all N» — раскрыть обрезанный список (Baymard: обрезать после 10) */
    panel.querySelectorAll('[data-ms4l-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var l = b.previousElementSibling;
        if (l) l.classList.remove('is-cut');
        b.remove();
      });
    });
    /* сортировка — сохраняем q, type и все активные фильтры */
    var sel = panel.querySelector('[data-ms4l-sort]');
    if (sel) sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      location.href = u.toString();
    });
  }


  /* тот же порядок, что в поп-апе: сначала готовые системы (по объёму),
     потом отдельные блоки, в самом низу запчасти. Shopify отдаёт фасеты по алфавиту. */
  function orderTabs() {
    var row = document.querySelector('.ms4l-sr__row[data-group="type"]');
    if (!row) return;
    var all = row.querySelector('.ms4l-sr__tab:not([data-val])');
    var tabs = [].slice.call(row.querySelectorAll('.ms4l-sr__tab[data-val]'));
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      var n = t.querySelector('.ms4l-sr__n');
      t._n = n ? parseInt(String(n.textContent).replace(/[^0-9]/g, ''), 10) || 0 : 0;
      /* у сгруппированных фасетов value = gid://shopify/FilterSettingGroup/...,
         поэтому уровень определяем по ПОДПИСИ, а не по значению */
      var lab = String(t.textContent || '').replace(/[\d,]+\s*$/, '').trim();
      t._t = tier(lab);
    });
    tabs.sort(function (a, b) { return (a._t - b._t) || (b._n - a._n); });
    tabs.forEach(function (t) { row.appendChild(t); });
    if (all) row.insertBefore(all, row.firstChild);
    /* бренды — просто по объёму */
    var brow = document.querySelector('.ms4l-sr__row--brand');
    if (brow) {
      var ch = [].slice.call(brow.querySelectorAll('.ms4l-sr__chip'));
      ch.forEach(function (c) {
        var n = c.querySelector('.ms4l-sr__n');
        c._n = n ? parseInt(String(n.textContent).replace(/[^0-9]/g, ''), 10) || 0 : 0;
      });
      ch.sort(function (a, b) { return b._n - a._n; });
      ch.forEach(function (c) { brow.appendChild(c); });
    }
  }


  /* --- 01.09: лупа возвращает уехавшую строку поиска ------------------------
     Сама строка уезжает при прокрутке без всякого скрипта: она лежит в потоке
     в секции header-mobile-navigation, ниже липкой шапки. Схлопывать её внутри
     .header-section было нельзя — липкий блок держит место в потоке, и документ
     под ним уехал бы вверх на её высоту (в Safari нет scroll anchoring, гасить
     это нечем).

     Скрипт делает ровно две вещи: показывает лупу, когда строка ушла с экрана,
     и по тапу возвращает её под шапку. Обработчик scroll не держим — уход и
     возврат ловит IntersectionObserver; одноразовый слушатель заводится только
     после тапа по лупе и снимает сам себя. */
  function ms4lBarPin() {
    var slot = document.querySelector('[data-ms4l-hslot]');
    if (!slot || slot.dataset.ms4lPin) return;
    slot.dataset.ms4lPin = '1';

    var de = document.documentElement;
    var MQ = window.matchMedia('(max-width: 1023px)');
    var away = false, pinned = false, mreset = null;
    /* 22.10.2026: S1 — на карточке строка свёрнута сервером (data-ms4l-collapsed, флаг ms4l_pdp_search_icon).
       Считаем её «ушедшей» сразу: IntersectionObserver элемент нулевой высоты считает видимым. */
    var collapsed = slot.hasAttribute('data-ms4l-collapsed');

    function pin(on) {
      if (pinned === on) return;
      pinned = on;
      de.classList.toggle('ms4l-pin', on);
      if (!on && mreset) { window.removeEventListener('scroll', mreset); mreset = null; }
    }

    if (collapsed) away = true;
    else new IntersectionObserver(function (e) {
      away = !e[0].isIntersecting;
      if (!MQ.matches) { de.classList.remove('ms4l-away'); pin(false); return; }
      de.classList.toggle('ms4l-away', away);
      if (!away) pin(false);          /* вернулись к верху — лупа больше не нужна */
    }, { threshold: 0 }).observe(slot);

    /* лупа: на document в фазе ПЕРЕХВАТА и с полной остановкой события.
       У темы на этой же лупе свой обработчик — он открывал боковую панель:
       сам drawer скрыт, но её затемняющий слой блокировал страницу.
       preventDefault() чужой обработчик не останавливает, перехват на
       документе идёт раньше любых обработчиков в дереве.
       href="/search" остаётся рабочим запасным вариантом. */
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || !t.closest('.thb-quick-search')) return;
      if (!MQ.matches || !away) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      if (collapsed && pinned) {        /* 22.10.2026: S1 — повторный тап по лупе закрывает поле */
        if (slot.contains(document.activeElement)) document.activeElement.blur();
        pin(false);
        return;
      }
      pin(true);
      if (collapsed) {
        /* фокус прямо в обработчике тапа — только так iOS откроет клавиатуру */
        var inp = slot.querySelector('input[name="q"]');
        if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }
        trk('search_icon_tap', { page_type: 'product' });
      }
      var y0 = window.scrollY || 0;
      if (mreset) window.removeEventListener('scroll', mreset);
      mreset = function () {
        if (Math.abs((window.scrollY || 0) - y0) < 120) return;
        if (collapsed && slot.contains(document.activeElement)) return;   /* пока печатают — поле не убираем */
        pin(false);
      };
      window.addEventListener('scroll', mreset, { passive: true });
    }, true);
  }

  function init() {
    dedupeSearchPage();
    mobileBar();
    ms4lBarPin();
    var mob = !window.matchMedia('(min-width: 1024px)').matches;
    document.querySelectorAll('form[action*="/search"]').forEach(function (f) {
      /* на телефоне поиск живёт только в строке под шапкой:
         лупа и её шторка скрыты, логику к ним не подключаем */
      if (mob && !f.closest('.ms4l-msbar')) return;
      AC(f);
    });
    fillCounts();
    orderTabs();
    setTimeout(orderTabs, 350);   /* повтор на случай перерисовки секции */
    facets();
    /* при смене ориентации/ширины строка появляется или исчезает */
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      mobileBar();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
